import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=1be851b4&scoped=true"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"
import style0 from "./profile.vue?vue&type=style&index=0&id=1be851b4&prod&lang=scss"
import style1 from "./profile.vue?vue&type=style&index=1&id=1be851b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be851b4",
  null
  
)

export default component.exports